// 状态

export const STATUS_TYPE = [
  {
    title: '入驻待审',
    val: 1,
    color: '#FEB00E',
  },
  {
    title: '入驻通过',
    val: 2,
    color: '#17C574',
  },
  {
    title: '入驻驳回',
    val: 3,
    color: '#FF4C4C',
  },
  {
    title: '上场待审',
    val: 4,
    color: '#FEB00E',
  },
  {
    title: '上场通过',
    val: 5,
    color: '#17C574',
  },
  {
    title: '上场驳回',
    val: 6,
    color: '#FF4C4C',
  },
];

export const MANAGE_STATUS_TYPE = [
  {
    title: '待提交',
    val: 1,
    color: '#FEB00E',
  },
  {
    title: '审核中',
    val: 2,
    color: '#2D63FF',
  },
  {
    title: '待上场',
    val: 3,
    color: '#2D63FF',
  },
  {
    title: '已上场',
    val: 4,
    color: '#17C574',
  },
  {
    title: '被驳回',
    val: 5,
    color: '#FF4C4C',
  },
  {
    title: '被驳回',
    val: 6,
    color: '#D9D9D9',
  },
  {
    title: '已下线',
    val: 7,
    color: '#D9D9D9',
  },
];

export const CREATE_TYPE = [
  {
    title: '通天塔',
    val: 1,
  },
];

export const STATUS_TYPE_MAP = {};
export const MANAGE_STATUS_TYPE_MAP = {};
export const STATUS_TYPE_COLOR_MAP = {};
export const MANAGE_STATUS_TYPE_COLOR_MAP = {};

function transformArr2Map(data = [], res = {}) {
  data.forEach((item) => {
    res[item.val] = item.title;
  });
}
function transformColorArr2Map(data = [], res = {}) {
  data.forEach((item) => {
    res[item.val] = item.color;
  });
}
transformArr2Map(STATUS_TYPE, STATUS_TYPE_MAP);

transformColorArr2Map(STATUS_TYPE, STATUS_TYPE_COLOR_MAP);

transformArr2Map(MANAGE_STATUS_TYPE, MANAGE_STATUS_TYPE_MAP);

transformColorArr2Map(MANAGE_STATUS_TYPE, MANAGE_STATUS_TYPE_COLOR_MAP);
